export const keyclick = {
  mounted(el) {
    el.addEventListener("keyup", e => {
      if (![13, 32].includes(e.keyCode)) return;
      // For input fields we won't emit a click event but a "trigger". This is
      // because input fields shouldn't listen to click events, otherwise
      // they will be fired whenever the user clicks on the field to focus it.
      if (el.tagName == "INPUT") {
        // Also, on input fields we don't want the space key to trigger
        // anything
        if (e.keyCode != 32) el.dispatchEvent(new Event("trigger"));
      } else if (e.target.click) e.target.click();
      else el.dispatchEvent(new Event("click"));
    });
  }
};
